import React, { useState } from "react";
import { Link } from "react-router-dom";
import Hero from "../components/landingPage/Hero";
import Section2 from "../components/landingPage/Section2";
import Section3 from "../components/landingPage/Section3";
import Section4 from "../components/landingPage/Section4";
import Section5 from "../components/landingPage/Section5";

const Home = () => {
  const [activeTest, setActiveTest] = useState("government");

  const stats = [
    { value: "500K+", label: "Active Users" },
    { value: "10K+", label: "Mock Tests" },
    { value: "95%", label: "Success Rate" },
    { value: "24/7", label: "Live Support" },
  ];

  const features = [
    {
      title: "AI-Powered Analysis",
      description: "Get personalized insights with our advanced AI algorithms",
      color: "from-purple-500 to-pink-500",
    },
    {
      title: "Secure Platform",
      description: "Bank-level security for all your assessments",
      color: "from-blue-500 to-cyan-500",
    },
    {
      title: "All India Ranking",
      description: "Compete with aspirants nationwide",
      color: "from-green-500 to-emerald-500",
    },
    {
      title: "Progress Tracking",
      description: "Monitor your improvement with detailed analytics",
      color: "from-orange-500 to-red-500",
    },
  ];

  const testCategories = [
    {
      id: "government",
      name: "Government Exams",
      tests: 45,
      color: "bg-blue-100 border-blue-500",
      iconColor: "text-blue-600",
    },
    {
      id: "competitive",
      name: "Competitive Exams",
      tests: 32,
      color: "bg-purple-100 border-purple-500",
      iconColor: "text-purple-600",
    },
    {
      id: "corporate",
      name: "Corporate Tests",
      tests: 28,
      color: "bg-green-100 border-green-500",
      iconColor: "text-green-600",
    },
    {
      id: "academic",
      name: "Academic Tests",
      tests: 67,
      color: "bg-orange-100 border-orange-500",
      iconColor: "text-orange-600",
    },
  ];

  const testimonials = [
    {
      name: "Rahul Sharma",
      role: "SSC CGL 2023 Topper",
      content:
        "TestSetu helped me secure AIR 12 with their realistic mock tests.",
    },
    {
      name: "Priya Patel",
      role: "Banking Aspirant",
      content: "The performance analytics transformed my preparation strategy.",
    },
    {
      name: "Amit Kumar",
      role: "CAT Aspirant",
      content: "Better than any other platform I've used. Highly recommended!",
    },
  ];

  return (
    <div className="">
      <Hero />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />

      <footer className="mt-10 border-t border-gray-200 bg-gray-100 py-12">
        <div className="container mx-auto px-4">
          <h2 className="mb-8 text-center text-2xl font-bold text-gray-800">
            App Privacy Policies & Legal
          </h2>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8">
            <Link
              to="/wallpaper/privacyPolicy"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-blue-50 hover:text-blue-600 hover:shadow-md"
            >
              Wallpaper App
            </Link>
            <Link
              to="/shayari/privacyPolicy"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-blue-50 hover:text-blue-600 hover:shadow-md"
            >
              Shayari App
            </Link>
            <Link
              to="/gk/privacyPolicy"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-blue-50 hover:text-blue-600 hover:shadow-md"
            >
              GK App
            </Link>
            <Link
              to="/ncert/privacyPolicy"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-blue-50 hover:text-blue-600 hover:shadow-md"
            >
              NCERT Solutions
            </Link>
            <Link
              to="/chemistry/privacyPolicy"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-blue-50 hover:text-blue-600 hover:shadow-md"
            >
              Chemistry App
            </Link>
            <Link
              to="/mathematics/privacyPolicy"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-blue-50 hover:text-blue-600 hover:shadow-md"
            >
              Mathematics App
            </Link>
            <Link
              to="/physics/privacyPolicy"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-blue-50 hover:text-blue-600 hover:shadow-md"
            >
              Physics App
            </Link>
            <Link
              to="/piano/privacyPolicy"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-indigo-50 hover:text-indigo-600 hover:shadow-md"
            >
              Piano App
            </Link>
            <Link
              to="/shayari/deleteAccount"
              className="rounded-lg border border-gray-100 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-red-50 hover:text-red-600 hover:shadow-md"
            >
              Delete Account (Shayari)
            </Link>
          </div>
          <div className="mt-8 text-center text-sm text-gray-500">
            &copy; {new Date().getFullYear()} TestSetu. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
